module.exports = __webpack_public_path__ + "img/mingbai2_8846ca53f.png";